// InsureDocs 5.30.0 — HealthSherpa follow-up alert colours (Henry 2026-10-29). The SERVER decides the band
// (services/healthsherpa/workspace.band, Central-time dates); this file only maps a band to colours + words, and
// mirrors the rule (bandFor) for display-only use and the node test.
//   overdue (< 0 days) = dark red + "OVERDUE", pinned to the top · 0–7 days = red · 8–14 = yellow · 15+ = orange ·
//   completed = green (on the board 7 days after completion, then only under "Completed").
// Solid chips, the same in light and dark mode; every text colour >= 4.5:1 on its chip (hsBands.test.mjs).

export const BAND_RED_MAX = 7;
export const BAND_YELLOW_MAX = 14;

export const BANDS = {
  overdue: { bg: '#7f1d1d', text: '#ffffff', label: 'Overdue' },
  red: { bg: '#c81e1e', text: '#ffffff', label: 'Due in 0–7 days' },
  yellow: { bg: '#facc15', text: '#1f1f1f', label: 'Due in 8–14 days' },
  orange: { bg: '#fb923c', text: '#1f1f1f', label: 'Due in 15+ days' },
  done: { bg: '#15803d', text: '#ffffff', label: 'Completed' },
};

export function bandFor(days, completed = false) {
  if (completed) return 'done';
  if (days < 0) return 'overdue';
  if (days <= BAND_RED_MAX) return 'red';
  if (days <= BAND_YELLOW_MAX) return 'yellow';
  return 'orange';
}

export const bandStyle = (band) => BANDS[band] || BANDS.orange;

// "3 days overdue" · "due today" · "due tomorrow" · "in 9 days" · "done"
export function dueWords(days, completed = false) {
  if (completed) return 'done';
  if (days < 0) return `${-days} day${days === -1 ? '' : 's'} overdue`;
  if (days === 0) return 'due today';
  if (days === 1) return 'due tomorrow';
  return `in ${days} days`;
}
